<script lang="ts"></script>

<style lang="scss">
    th {
        --width: var(--width-item-level);
    }
</style>

<th></th>
